<template>
  <modal name="modal-packing-checklist" class="modal-inner modal-packing-checklist" transition="pop-out" :width="modalWidth" height="auto" :scrollable="true" :adaptive="true" :clickToClose="false">
    <span class="close-button" @click="cancel"><BaseIcon icon="times-circle" class="text-white" /></span>
    <div class="modal-header">
      {{ $t('order_log.completion_checklist_title') }}
    </div>
    <div class="modal-body">
      <p class="text-sm text-gray-600 mb-4">{{ $t('order_log.completion_checklist_desc') }}</p>
      <div class="flex items-center py-1 mb-2 pb-2 border-b border-secondary-400">
        <input type="checkbox" id="packing-check-all" :checked="allChecked" @change="setAll($event.target.checked)" class="mr-2 cursor-pointer" />
        <label for="packing-check-all" class="text-sm font-semibold text-gray-800 cursor-pointer">
          {{ $t('order_log.check_all') }}
        </label>
      </div>
      <div v-for="item in items" :key="item.key" class="flex items-center py-1">
        <input type="checkbox" :id="`packing-check-${item.key}`" v-model="item.checked" class="mr-2 cursor-pointer" />
        <label :for="`packing-check-${item.key}`" class="text-sm text-gray-800 cursor-pointer">
          {{ $t(`order_log.completion_checklist_items.${item.key}`) }}
        </label>
      </div>
    </div>
    <div class="modal-footer">
      <div class="footer-container clearfix">
        <button class="btn-blue-outline px-3 py-2 float-left" @click="cancel">{{ $t('order_log.cancel') }}</button>
        <button class="btn-blue px-3 py-2 float-right" :disabled="!allChecked" :class="{ 'opacity-50 cursor-not-allowed': !allChecked }" @click="confirm">
          {{ $t('order_log.confirm_move') }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
const MODAL_WIDTH = 500;

import { COMPLETION_CHECKLIST_KEYS } from "@/utils/orderChecklists";

export default {
  name: "packingChecklistModal",

  props: {
    // the order being moved into Färdig; a new order starts
    // with every box unticked
    order: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      items: [],
    };
  },

  computed: {
    allChecked() {
      return this.items.length > 0 && this.items.every((item) => item.checked);
    },
  },

  watch: {
    order: {
      immediate: true,
      handler() {
        this.reset();
      },
    },
  },

  methods: {
    setAll(checked) {
      this.items.forEach((item) => {
        item.checked = checked;
      });
    },

    confirm() {
      if (!this.allChecked) return;
      const items = this.items.map((item) => item.key);
      this.reset();
      this.$modal.hide("modal-packing-checklist");
      this.$emit("confirm", items);
    },

    cancel() {
      this.reset();
      this.$modal.hide("modal-packing-checklist");
      this.$emit("cancel");
    },

    reset() {
      this.items = COMPLETION_CHECKLIST_KEYS.map((key) => ({ key, checked: false }));
    },
  },

  created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? window.innerWidth : MODAL_WIDTH;
  },
};
</script>

<style scoped>
.modal-packing-checklist ::v-deep .modal-body {
  max-height: 55vh;
  overflow-y: auto;
  /* the footer is absolutely positioned over the modal bottom — end the
     scroll area above it instead of padding inside the scroll content */
  padding-bottom: 15px;
  margin-bottom: 62px;
}
</style>
